import React, { Component } from 'react';
import { Spin } from 'antd';
import { history } from '../../container/History';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/index';

class Loading extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props,
        }
    }

    componentDidMount = () =>{
        const { location } = this.props;
        const fromState = location.state && location.state.from;
        this.setState({redirectedFrom : fromState})
    }

    componentWillReceiveProps(prevProps) {
        const { isadmin, isspecialist } = this.props;
        if ((isadmin != prevProps.isadmin) || (isspecialist != prevProps.isspecialist)) {
            if(this.state.redirectedFrom)  history.push(this.state.redirectedFrom.pathname)
        }
      }


    render() {
        return (
            <div className='page-loading'>
                <Spin tip="Loading Page..." />
            </div>
        );
    }

}

const mapStateToProps = (state) => ({
    isadminLoading: state.isadminreducer.loading,
    isadmin: state.isadminreducer.isadmin,
    isspecialist: state.isadminreducer.isspecialist,
  });
  
  const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  });
  
  export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Loading));


// WEBPACK FOOTER //
// ./src/components/HOC/loading.js